import React from 'react';

const SupportIcon = () => (
  <svg className="support__icon" xmlns="http://www.w3.org/2000/svg" width="17.884" height="19" viewBox="0 0 17.884 19">
    <path
      d="M26.676,4.143V3.532a6.707,6.707,0,0,0-1.75-4.6A6.039,6.039,0,0,0,20.444-3h-.6a6.041,6.041,0,0,0-4.486,1.932,
        6.714,6.714,0,0,0-1.75,4.6v.615A2.712,2.712,0,0,0,11.2,6.831V7.959a2.7,2.7,0,0,0,2.7,2.7h1.455a.59.59,0,0,0,
        .591-.591V4.718a.59.59,0,0,0-.591-.591H14.8v-.6a5.089,5.089,0,0,1,5.05-5.349h.6a5.091,5.091,0,0,1,5.05,
        5.349v.6h-.56a.59.59,0,0,0-.591.591v5.345a.59.59,0,0,0,.591.591h.532a3.023,3.023,0,0,1-2.472,2.917,1.772,1.772,
        0,0,0-1.66-1.131H20.148a1.78,1.78,0,0,0,0,3.56h1.187a1.784,1.784,0,0,0,1.691-1.234,4.6,4.6,0,0,0,1.573-.552,
        4.262,4.262,0,0,0,2.054-3.571,2.706,2.706,0,0,0,2.432-2.688V6.827A2.7,2.7,0,0,0,26.676,4.143Zm1.23,
        2.684V7.955a1.521,1.521,0,0,1-1.518,1.518h-.863V5.31h.863A1.521,1.521,0,0,1,27.906,6.827ZM14.771,
        5.31V9.472h-.863A1.521,1.521,0,0,1,12.39,7.955V6.827A1.521,1.521,0,0,1,13.908,5.31h.863Zm6.563,
        9.508H20.148a.6.6,0,1,1,0-1.19h1.187a.6.6,0,1,1,0,1.19Z"
      transform="translate(-11.2 3)"
    />
  </svg>
);

export default SupportIcon;
